import { OrderProduct } from "../../types/order";
import { useTranslation } from "../../core/translation.core";

export function BundleProductBadge({ orderProduct }: { orderProduct: OrderProduct }) {
  const { t, msg } = useTranslation();

  if (orderProduct.productType !== "bundle") return null;

  return <div className="bg-her-robinEggBlue px-2 py-1 rounded-md text-black text-xs">{t(msg.product.bundleProducts)}</div>;
}
